import router from "src/routes/routes";
import { createCrudService } from "./crudFactory";
import CommonAPIService from "./commonHandler";

const api = new CommonAPIService(router);

const baseService = createCrudService("complianceForms", [], router);

export const complianceFormsService = {
  ...baseService,

  send: async (payload) => {
    return api.postCall("/api/complianceForms/send", payload);
  },

  sendBatch: async (payload) => {
    return api.postCall("/api/complianceForms/send-batch", payload);
  },

  getByToken: async (token) => {
    return api.getCall(`/api/complianceForms/sign/${token}`);
  },

  getPortal: async (token, params) => {
    return api.getCall(`/api/complianceForms/portal/${token}`, params);
  },

  sendPortal: async (payload) => {
    return api.postCall("/api/complianceForms/send-portal", payload);
  },

  submitSignature: async (token, payload) => {
    return api.postCall(`/api/complianceForms/sign/${token}`, payload);
  },

  getClientCompliance: async (clientId) => {
    return api.getCall(`/api/complianceForms/client/${clientId}`);
  },

  getExpiringForms: async (clientId) => {
    return api.getCall(`/api/complianceForms/client/${clientId}/expiring`);
  },

  getDashboard: async (params) => {
    return api.getCall("/api/complianceForms/dashboard", params);
  },

  getSignedPdf: async (token) => {
    return api.getBlobCall(`/api/complianceForms/sign/${token}/pdf`);
  },

  revoke: async (signatureId) => {
    return api.postCall(`/api/complianceForms/${signatureId}/revoke`);
  },

  regeneratePdfs: async () => {
    return api.postCall("/api/complianceForms/regenerate-pdfs");
  },

  getDashboardSummary: async () => {
    return api.getCall("/api/complianceForms/dashboard-summary");
  },

  getClientFormConfig: async (clientId) => {
    return api.getCall(`/api/complianceForms/client/${clientId}/config`);
  },

  saveClientFormConfig: async (clientId, formIds) => {
    return api.putCall(`/api/complianceForms/client/${clientId}/config`, { formIds });
  },
};
